module.exports = __webpack_public_path__ + "static/media/2025 융합과학교육원 본원 메이커 발명 캠프 포스터.8fa9e8cb.png";